import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Stringable, StringableValues } from '../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../Interfaces/JSONRpcResponse'
import { KebabCasePipe } from '../../../../pipes/string/kebab-case.pipe'
import { DialogService, TagTiersService } from '../../../../services'
import { ConfirmComponent } from '../dialogs/confirm-dialog/confirm.component'
import { DossierAlerteDialogComponent } from '../dialogs/dossier-alerte-dialog/dossier-alerte-dialog.component'
import { Subject } from 'rxjs'
const KEY = 'dossier-alerte'

@Component({
	selector: 'atyl-dossier-alerte',
	templateUrl: './dossier-alerte.component.html',
	styleUrls: ['./dossier-alerte.component.scss'],
})

@Stringable({
	path: 'views/partials/layout/dossier-alerte',
	key: KEY,
})
export class DossierAlerteComponent {

	@StringableValues(KEY)
	strings: any
	@Input() dossier: any
	@Input() demandeFormulaire: any
	@Input() demandeDocument: any
	@Input() hasOrigine: boolean
	@Input() title: string = '';
	@Input() alerteChangeEvent: Subject<boolean>;
	@Output() alertesModif = new EventEmitter<any>();
	tier: any
	canAddNewAlerts: boolean = false;
	listAlerts: any = [];
	newCreatedId: any = null;
	isTiersAlertes: boolean = false;
	subscriptions: any = [];
	constructor(
		public dialog: MatDialog,
		private changeDetectorRef: ChangeDetectorRef,
		private tagTiersService: TagTiersService,
		private kebabcasePipe: KebabCasePipe,
		private dialogService: DialogService
	) {

	}

	ngOnInit(): void {
		/*this.tier = this.dossier.tiers
		this.isTiersAlertes = this.tier && !this.hasOrigine
		this.setListAlert();*/
		if(this.alerteChangeEvent != undefined && this.alerteChangeEvent){
			this.subscriptions.push(
				this.alerteChangeEvent.subscribe(event=>{
					if(event){
						this.setListAlert();
					}
				})
			)
		}
	}

	ngOnChanges(changes): void {
		if(changes['dossier']){
			this.tier = this.dossier.tiers
			this.isTiersAlertes = this.tier && !this.hasOrigine
			this.setListAlert();
		}
	}

	ngOnDestroy() {
		this.subscriptions.forEach(sub => {
			sub.unsubscribe();
		});
	}

	setListAlert(){
		if (this.isTiersAlertes) {
			this.listAlerts = [];
			this.tagTiersService.getTiersTags(this.tier.ID).subscribe((data: JSONRpcResponse) => {
				this.listAlerts = data.result
				this.changeDetectorRef.detectChanges()
			
				console.log("AAAA DEBUG DOSSIER ALERTE (tier id)", {
					listAlerts: this.listAlerts,
					tier: this.tier,
					hasOrigine: this.hasOrigine,
					cond: !this.hasOrigine,
					isTiersAlertes: this.isTiersAlertes
				})
			})
		} else {
			this.tagTiersService.getOrigineTags(this.origineConfig()).subscribe((data: JSONRpcResponse) => {
				this.listAlerts = data.result
				this.changeDetectorRef.detectChanges()
			
				
				console.log("AAAA DEBUG DOSSIER ALERTE (origineConfig)", {
					listAlerts: this.listAlerts,
					tier: this.tier,
					hasOrigine: this.hasOrigine,
					cond: !this.hasOrigine,
					isTiersAlertes: this.isTiersAlertes
				})
			})
		}
	}
	openTagAddModal() {
		this.dialogService.open(DossierAlerteDialogComponent, {
			data: {
				tiers: this.tier
			},
			draggable: true,
			minimizable: true,
			width: '40vw',
		}, (res: any) => {

			if (res) {
				// tag code, tiers id, and options if exist
				this.tagTiersService.addTagToTiers(res.alerte.tag.code, this.tier.ID, {
					label: res.libelle || `${this.kebabcasePipe.transform(this.title)}_${res.alerte.tag.code}_${this.listAlerts.length}`,
					origine: this.origineConfig()
				}).subscribe((data: JSONRpcResponse) => {
					res.alerte.libelle = res.libelle
					this.listAlerts.push(res.alerte)
					this.changeDetectorRef.detectChanges()
					this.newCreatedId = data.result.tag
					this.alertesModif.emit();
				})
			}
		})
	}

	removeTagFromTiers(alerte: any) {
		let tag_id = alerte.id || this.newCreatedId

		this.dialogService.open(ConfirmComponent, {
			data: {
				libelle: 'Etes-vous sur de vouloir supprimer cette particularité ?',
				// libelle: 'Etes-vous sur de vouloir supprimer cette alerte ?',
			},
			draggable: true
		}, (res: string) => {
			if (res === 'true') {
				this.tagTiersService.removeTagFromTiers(tag_id, this.tier.ID).subscribe((data) => {
					if (data) {
						this.listAlerts.splice(this.listAlerts.indexOf(alerte), 1)
					}
					this.changeDetectorRef.detectChanges()
					this.alertesModif.emit();
				})
			}
		})
	}
	hexToRgbA(hex: string, alpha: any = 200) {
		let color: any
		let newAlpha = Number.parseInt(alpha, 10)

		if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
			color = hex.substring(1).split('')
			if (color.length == 3) {
				color = [color[0], color[0], color[1], color[1], color[2], color[2]]
			}
			color = '0x' + color.join('')
			return 'rgba(' + [(color >> 16) & 255, (color >> 8) & 255, color & 255].join(',') + ',' + newAlpha / 255 + ')'
		}
	}

	origineConfig() {
		return {
			hasOrigine: this.demandeDocument != null || this.demandeFormulaire != null,
			type: this.demandeDocument != null ? 'document' : this.__type__(),
			demandeFormulaire: this.demandeFormulaire,
			demandeDocument: this.demandeDocument
		}
	}


	private __type__() {
		return this.demandeFormulaire != null ? 'formulaire' : undefined
	}
}
